import { useSelector } from "react-redux";
import { selectEssSwitch } from "../store/slices/essSwitchSlice";
import { selectTesSwitch } from "../store/slices/tesSwitchSlice";
import { selectTgsSwitch } from "../store/slices/tgsSwitchSlice";

import { flexBoxCenter } from "../styles/commonStyles";
import styled, { css } from "styled-components";

import HeaterStatus from "./HeaterStatus";
import ControlBox from "../controlBox/ControlBox";
import SwitchDetailContainer from "./SwitchDetailContainer";

const SwitchWrapper = ({
  swtName,
  location,
  machine,
  isMobile,
  specificLocation,
  indivLocationName,
  deviceMac,
}) => {
  const { essSwitch, tgsSwitch,flatTgsSwitch, tesSwitch,flatEssSwitch: flatSwitchStatus,flatTesSwitch } = useSelector(
    swtName === "ess"
      ? selectEssSwitch
      : swtName === "tgs"
      ? selectTgsSwitch
      : selectTesSwitch
  );

  const switchStatus =
    swtName === "ess" ? flatSwitchStatus : swtName === "tgs" ? flatTgsSwitch : flatTesSwitch;

  const { isFaults, isOff } = switchStatus[location][machine];

  return (
    <Wrapper isFaults={isFaults}>
      <InnerWrapper>
        <SectionMain>
          <ControlBox location={location} machine={machine} swtName={swtName} />
          <SwitchDetailContainer
            location={location}
            specificLocation={specificLocation}
            machine={machine}
            swtName={swtName}
            isFaults={isFaults}
          />
        </SectionMain>

        {swtName !== "tgs" && (
          <SectionSub>
            <HeaterStatus
              swtName={swtName}
              location={location}
              specificLocation={specificLocation}
              machine={machine}
              isFaults={isFaults}
              isOff={isOff}
              indivLocationName={indivLocationName}
            />
          </SectionSub>
        )}
      </InnerWrapper>
    </Wrapper>
  );
};

export default SwitchWrapper;

const Wrapper = styled.div`
  width: 1205px;
  ${flexBoxCenter}

  background: transparent linear-gradient(180deg, #1f344c 0%, #060d19 100%);
  border: 1px solid #000000;
  border-radius: 26px 0px 26px 26px;

  ${({ isFaults }) =>
    isFaults &&
    css`
      border: 1px solid red;
    `}
`;
const InnerWrapper = styled.div`
  width: 1184px;
  margin: 11px 0;

  background: #233a54;
  box-shadow: inset 0px 0px 6px #000000;
  border: 1px solid #142033;
  border-radius: 15px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

const SectionMain = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SectionSub = styled.div`
  width: 100%;
`;
